module.exports = __webpack_public_path__ + "static/larry-ellison-5fbb991e7ae76dd436201056639a5bc8.jpg";